import React, { useState, useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import { Model } from "survey-core";
import { Survey } from "survey-react-ui";
import { useAuth0 } from "@auth0/auth0-react";

const DisplayForm = () => {
  const { formId } = useParams(); // Get formId from path
  const location = useLocation();

  const [survey] = useState(new Model());
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [completedOn, setCompletedOn] = useState("");
  const [test, setTest] = useState("");
  const [isCheckingAuth, setIsCheckingAuth] = useState(true);
  const [token, setToken] = useState("")

  const { getAccessTokenSilently, isLoading, isAuthenticated, loginWithRedirect } = useAuth0();

  // ✅ Ensure Auth0 session is checked before redirecting
  useEffect(() => {
    const checkAuth = async () => {
      if (isLoading) return; // Wait until Auth0 finishes loading

      try {
        const t = await getAccessTokenSilently();
        setToken(t)
        setIsCheckingAuth(false); // User is authenticated, proceed to load form
      } catch (error) {
        console.log("No valid session, redirecting to login...");
        localStorage.setItem("postLoginRedirect", location.pathname + location.search);

        loginWithRedirect({
          authorizationParams: {
            redirect_uri: `${window.location.origin}/auth-callback`,
          },
        });

      }
    };

    checkAuth();
  }, [isLoading, isAuthenticated]);

  // ✅ Fetch survey only after authentication is checked
  useEffect(() => {
    if (isCheckingAuth || !formId) return;

    const fetchForm = async () => {
      try {
        const formData = await fetch(
          `${import.meta.env.VITE_API_URL}/api/forms/${formId}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
            }
          }
        );
        const data = await formData.json();
        survey.fromJSON(data.formSchema);
        survey.data = data.content;

        if (data.content.status === "Completed" || data.content.status === "Revoked") {
          survey.mode = "display";
          setCompletedOn(data.createdAt);
          setTest(data.formName)
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchForm();
  }, [formId, isCheckingAuth]);

  if (isLoading || isCheckingAuth) return <div>Authenticating...</div>;
  if (loading) return <div>Loading form...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <div>
      <style>{`
        @media screen {
          .print-tearoff {
            display: none !important;
          }
        }
        @media print {
          @page {
            margin: 0.5in;
          }

          .print-tearoff {
            display: block !important;
            height: 120px;
            margin-bottom: 20px;
            padding: 8px 0 12px;
            border-bottom: 2px dashed #000;
            page-break-inside: avoid;
            break-inside: avoid;
          }

          .print-tearoff-row {
            display: flex;
            justify-content: center;
            min-height: 50px;
          }

          .print-tearoff-label {
            border-top: 1px dashed #000;
            border-bottom: 1px dashed #000;
            min-width: 100%;
            text-align: left;
            padding-bottom: 24px;
          }

          .survey-container {
            margin-top: 0;
          }
        }
      `}</style>
      <div className="survey-container">
        <div className="print-tearoff">
          <div className="print-tearoff-row">
            <p className="print-tearoff-label">Office Use</p>
          </div>
        </div>
        <Survey model={survey} />
      </div>
      <div>
        <p>Completed On: {completedOn}</p>
        <p>Form Name: {test}</p>
      </div>
      
    </div>
  );
};

export default DisplayForm;